module.exports = __webpack_public_path__ + "static/img/Home28@2x.cbe94b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home28@2x.png
// module id = iZBv
// module chunks = 1